import { RESET_STATE } from 'store/global/actions';
import { FEE_TYPES_ACTION_TYPE } from 'store/system/actions';

const initialState = {};

const feeTypesSchemaReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case FEE_TYPES_ACTION_TYPE.GET_SCHEMA:
      return payload;

    case RESET_STATE:
      return initialState;

    default:
      return state;
  }
};

export default feeTypesSchemaReducer;
